import * as React from "react";
import { BottomNavigation, Text, Button, Title } from "react-native-paper";
import { backgroundMenuColor } from "../commonStyles";
import IconFontAwesome from "react-native-vector-icons/FontAwesome";
import IconIonicons from "react-native-vector-icons/Ionicons";
import TestLoriiniRoute from "../Routes/TestLoriiniRoute";
import HomeRoute from "../Routes/HomeRoute";
import ColorsRoute from "../Routes/ColorsRoute";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import isPWA from "./../common/isPWA";
import { Dimensions, Platform } from "react-native";
import t from "../translations";

const icons = {
  home: "home",
  user: "pie-chart",
  colors: "color-filter",
  info: "book",
};

const FooterMenu = (props) => {
  const [index, setIndex] = React.useState(props.activeFotterMenu);

  const [routes, setRoutes] = React.useState([
    {
      key: "home",
      title: "Home",
      icon: icons.home + "-outline",
      iconType: "IconIonicons",
    },
    {
      key: "user",
      title: "",
      icon: icons.user + "-outline",
      iconType: "IconIonicons",
    },
    {
      key: "colors",
      title: "",
      icon: icons.colors + "-outline",
      iconType: "IconIonicons",
    },
    // },
    // {
    //   key: "info",
    //   title: "Baza Wiedzy",
    //   icon: icons.info + "-outline",
    //   iconType: "IconIonicons",
    // },
  ]);

  React.useEffect(() => {
    setIndex(props.activeFotterMenu);

    switch (props.activeFotterMenu) {
      case 0:
        {
          const routes0 = routes[0];
          routes0.icon = icons.home;

          const routes1 = routes[1];
          routes1.icon = icons.user + "-outline";

          const routes2 = routes[2];
          routes2.icon = icons.colors + "-outline";

          routes0.title = t('footerMenu_routes0_home');
          routes1.title = "";
          routes2.title = "";
          // const routes3 = routes[3];
          // routes3.icon = icons.info + "-outline";
          // setRoutes([routes0, routes1, routes2, routes3]);
          setRoutes([routes0, routes1, routes2]);
        }
        break;
      case 1:
        {
          const routes0 = routes[0];
          routes0.icon = icons.home + "-outline";
          const routes1 = routes[1];
          routes1.icon = icons.user;
          const routes2 = routes[2];
          routes2.icon = icons.colors + "-outline";

          routes0.title = "";
          routes1.title = t('footerMenu_routes1_your_color');
          routes2.title = "";
          // const routes3 = routes[3];
          // routes3.icon = icons.info + "-outline";
          // setRoutes([routes0, routes1, routes2, routes3]);
          setRoutes([routes0, routes1, routes2]);
        }
        break;
      case 2:
        {
          const routes0 = routes[0];
          routes0.icon = icons.home + "-outline";
          const routes1 = routes[1];
          routes1.icon = icons.user + "-outline";
          const routes2 = routes[2];
          routes2.icon = icons.colors;
          routes0.title = "";
          routes1.title = "";
          routes2.title = t('footerMenu_routes2_colors');
          // const routes3 = routes[3];
          // routes3.icon = icons.info + "-outline";
          // setRoutes([routes0, routes1, routes2, routes3]);
          setRoutes([routes0, routes1, routes2]);
        }
        break;
      case 3:
        {
          const routes0 = routes[0];
          routes0.icon = icons.home + "-outline";
          const routes1 = routes[1];
          routes1.icon = icons.user + "-outline";
          const routes2 = routes[2];
          routes2.icon = icons.colors + "-outline";
          // const routes3 = routes[3];
          // routes3.icon = icons.info;
          // setRoutes([routes0, routes1, routes2, routes3]);
          setRoutes([routes0, routes1, routes2]);
        }
        break;
      default:
        setRoutes(routes);
        break;
    }
  }, [props]);

  const renderScene = BottomNavigation.SceneMap({
    home: () => <HomeRoute {...props} />,
    user: () => <TestLoriiniRoute {...props} />,
    colors: () => <ColorsRoute {...props} />,
    // agreement: () => <AgreementRoute {...props} />,
  });

  const renderIcon = (props) => {
    const { route } = props;
    return route.iconType === "IconIonicons" ? (
      <IconIonicons name={route.icon} size={23} />
    ) : (
      <IconFontAwesome name={route.icon} size={23} />
    );
  };
  const { height } = Dimensions.get("window");
  return (
    <BottomNavigation
      barStyle={{
        backgroundColor: backgroundMenuColor,
        paddingBottom:
          (isPWA() && height > 700) || (Platform.OS === "web" && height > 700)
            ? 15
            : 0,
      }}
      navigationState={{ index, routes }}
      onIndexChange={props.setActiveFooterMenu}
      renderScene={renderScene}
      renderIcon={renderIcon}
    />
  );
};

export default connect((state) => {
  return {
    activeFotterMenu: state.activeFotterMenu,
  };
}, actionCreators)(FooterMenu);
